export const SET_MULTIPLE_DYNAMIC_FORMS_PAGE =
  'SET_MULTIPLE_DYNAMIC_FORMS_PAGE';
export const SET_PAGENUMBERS = 'SET_PAGENUMBERS';
export const SET_LASTPAGE = 'SET_LASTPAGE';
